package navigation.settings.currency.allowedcurrencies

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.settings.domain.repository.ConfigurationRepository
import com.essntl.core.settings.ui.AllowedCurrenciesEvent
import com.essntl.core.settings.ui.AllowedCurrenciesState
import com.essntl.core.settings.ui.AllowedCurrenciesViewModel
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.currency.domain.repository.CurrencyRepository

class AllowedCurrenciesScreenModel(
    configurationRepository: ConfigurationRepository,
    currencyRepository: CurrencyRepository,
    loadingManager: LoadingManager,
) : StateScreenModel<AllowedCurrenciesState>(AllowedCurrenciesState()) {

    private val viewModel =
        AllowedCurrenciesViewModel(
            configurationRepository = configurationRepository,
            currencyRepository = currencyRepository,
            loadingManager = loadingManager,
            state = mutableState,
            scope = screenModelScope,
        )

    fun onEvent(event: AllowedCurrenciesEvent) = viewModel.onEvent(event)
}